/* eslint-disable no-nested-ternary */
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useSelectedMenuStore } from 'store'
import MobileMenu from 'components/PageWrapper/MobileMenu'
import { PRIMARY_NAV, HAMBURGUER_BUTTON } from 'components/PageWrapper/menus'
import TabBarButton from './TabBarButton'

const TabBar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const { selectedMenu, updateSelectedMenu } = useSelectedMenuStore()
  const navigate = useNavigate()

  return (
    <>
      <MobileMenu isOpen={isMenuOpen} setOpen={setMenuOpen} />
      <nav className='w-full h-[4.5rem] shadow-navMob bg-white grid grid-cols-[repeat(5,_1fr)] gap-3 items-center justify-center fixed rounded-t-2xl bottom-0 z-70 md:hidden py-3 px-4 border-t border-t-gray-300'>
        {[...PRIMARY_NAV, HAMBURGUER_BUTTON].map((b) => (
          <TabBarButton
            key={b.id}
            icon={
              <b.Icon
                className={
                  (isMenuOpen && b.id === 'menu') ||
                  (!isMenuOpen &&
                    (selectedMenu === `/${b.id}` || selectedMenu === b.id))
                    ? 'stroke-[#08724C]'
                    : b.id === 'home'
                    ? 'stroke-green-800'
                    : 'stroke-[#A197C1]'
                }
              />
            }
            isSelected={
              (isMenuOpen && b.id === 'menu') ||
              (!isMenuOpen &&
                (selectedMenu === `/${b.id}` || selectedMenu === b.id))
            }
            label={b.text}
            onClick={() => {
              if (b.id === 'menu') {
                setMenuOpen((prevState) => !prevState)
              } else {
                updateSelectedMenu(b.id)
                navigate(`/${b.id}`)
              }
            }}
          />
        ))}
      </nav>
    </>
  )
}

export default TabBar
